import { h } from "preact";
import { markups as allMarkups } from "../../../data/markups.js";

/**
 * Чекбоксы наценок.
 *
 * Пропсы:
 *   markups  — массив индексов выбранных наценок
 *   ontoggle — колбэк (idx) => void
 */
export function Markups({ markups = [], ontoggle }) {
  return h("fieldset", { class: "markups" },
    allMarkups.map((markup, idx) => {
      const checked = markups.includes(idx);
      return h("label", {
        key: idx,
        class: "markups__item" + (checked ? " is--selected" : ""),
      },
        h("input", {
          type: "checkbox",
          checked,
          onchange: () => ontoggle(idx),
          class: "markups__checkbox",
        }),
        h("span", { class: "markups__text" },
          markup.title,
          h("span", { class: "markups__percent" }, ` +${markup.percent}%`)
        )
      );
    })
  );
}
